import { PartyRelationsController } from 'controllers/Party/Relations/PartyRelationsController'
import { useController } from 'customHooks/useController'
import React from 'react'
import { SellingPartyDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ErrorMessage } from 'store/Application/appActions'
import { useOrganizationContext } from 'utils/useOrganizationContext'

export function useSellingParties(shouldCall?: boolean) {
  const { organizationId } = useOrganizationContext()

  const { controller, loading } = useController(
    () => new PartyRelationsController(organizationId)
  )

  const [sellingParties, setSellingParties] = React.useState<SellingPartyDto[]>(
    []
  )

  React.useEffect(() => {
    if (shouldCall === undefined || shouldCall === true) {
      controller
        .GetSellerParties()
        .then(setSellingParties)
        .catch((err) => ErrorMessage('suppliers', err['message']))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    loading,
    sellingParties,
  }
}
